// @flow
import React from 'react'
import firebase from 'firebase/app'
import 'firebase/database'
import './styles.scss'

import iconLove from '../../images/icon-love.svg'
import iconTouching from '../../images/icon-touching.svg'
import iconRomantic from '../../images/icon-romantic.svg'

export class ReactionCount extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      loveVotes: 0,
      touchingVotes: 0,
      romanticVotes: 0
    }

    // Init Firebase
    const config = {
      apiKey: 'AIzaSyDK2K4LgTvb2KcTE6bUMDElqGxYKCLlo-c',
      authDomain: 'emoji-reactions.europe-west1.firebasedatabase.app',
      databaseURL: 'https://emoji-reactions.europe-west1.firebasedatabase.app',
      storageBucket: 'ta-interaktiv.appspot.com'
    }
    if (!firebase.apps.length) {
      // console.log('firebase.apps', firebase.apps)
      firebase.initializeApp(config)
    }
  }

  getVotes() {
    // console.log('get votes rom firebase for', this.state.tippID)
    /* firebase request */
    firebase
      .database()
      .ref(this.props.articleID + '/' + this.props.storyID)
      .once('value')
      .then(snapshot => {
        const loveVotes = snapshot.child('love').val()
        const touchingVotes = snapshot.child('touching').val()
        const romanticVotes = snapshot.child('romantic').val()
        this.setState({
          loveVotes: loveVotes || 0,
          touchingVotes: touchingVotes || 0,
          romanticVotes: romanticVotes || 0
        })
      })
  }

  componentDidMount() {
    this.getVotes()
  }

  render() {
    return (
      <div className='reaction-count'>
        <div className='label-wrapper'>
          <div className='ui label love'>
            <img className='icon' src={iconLove} unselectable='on' />
            <span className='count'>{this.state.loveVotes}</span>
          </div>

          <div className='ui label touching'>
            <img className='icon' src={iconTouching} />
            <span className='count'>{this.state.touchingVotes}</span>
          </div>

          <div className='ui label romantic'>
            <img className='icon' src={iconRomantic} />
            <span className='count'>{this.state.romanticVotes}</span>
          </div>
        </div>
      </div>
    )
  }
}
